/* ==========================================================================
   MICHEL PIZA · redesign layer · October 2026
   0. Prices: no ",00" when the theme formats a price in the browser.
      Menu bar: SHOP and DISCOVER open as a list over the faded page, on
      mouse over or click (computers).
   1. Homepage: full-screen images that change one at a time, with the
      wheel or trackpad on computers and with a swipe on phones.
   2. Collections: one FILTERS menu with Style, Model, Colour and Size,
      filters that combine, cleaner colour list, Boots in Style; it opens
      on mouse over or click, like the menu bar.
   3. Product page: colour name next to "Color", one sizing message with a
      size guide link, pickup info under the button, open/closed markers.
   3b. Product page: size systems (IT/EU, UK, US, MX) above the sizes.
   4. Our story: paragraphs and a closing statement.
   5. Bag: one (Dust)Bag per pair, kept in step when pairs are removed;
      asking for more than is in stock no longer empties the bag on screen.
   The bag drawer and discount codes are in mp-cart.js.
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  var body = document.body;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function each(selector, fn, root) { toArray((root || document).querySelectorAll(selector)).forEach(fn); }
  function isMouse(e) { return !e.pointerType || e.pointerType === 'mouse'; }
  var wideScreen = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: true };

  /* The veil: while a menu or the filters are open on a computer, the page
     behind fades to white, as on The Row. Clicking it closes them. */
  var veilEl = null;
  var veilOwners = {};
  function setVeil(owner, on) {
    veilOwners[owner] = !!on;
    var any = Object.keys(veilOwners).some(function (k) { return veilOwners[k]; });
    if (any && !veilEl) {
      veilEl = document.createElement('div');
      veilEl.className = 'mp-veil';
      veilEl.setAttribute('aria-hidden', 'true');
      body.appendChild(veilEl);
      void veilEl.offsetWidth; // let the fade run the first time too
      veilEl.addEventListener('click', function () { closeMenus(); });
    }
    html.classList.toggle('mp-veiled', any);
  }
  // Wheel gestures. A trackpad goes on sending wheel events for a moment
  // after a swipe (momentum). A menu that opens while that is still going on
  // stays open; the next swipe or turn of the wheel closes it.
  var wheelPrev = 0;
  var wheelLast = 0;
  window.addEventListener('wheel', function () {
    wheelPrev = wheelLast;
    wheelLast = Date.now();
  }, { capture: true, passive: true });
  function wheelGoingOn() { return Date.now() - wheelLast < 160; }
  function wheelContinues() { return wheelLast - wheelPrev < 160; }

  // Asks every open menu to close (except the one named).
  function closeMenus(except) {
    var event;
    try {
      event = new CustomEvent('mp:close-menus', { detail: { except: except || null } });
    } catch (err) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('mp:close-menus', false, false, { except: except || null });
    }
    document.dispatchEvent(event);
  }


  /* ------------------------------------------------------------------
     0. PRICES
     ------------------------------------------------------------------ */
  function initMoney() {
    var currency = window.theme && window.theme.Currency;
    if (!currency || typeof currency.formatMoney !== 'function' || currency.mpTrimmed) { return; }
    var original = currency.formatMoney;
    currency.formatMoney = function () {
      var out = original.apply(this, arguments);
      // "€495,00" -> "€495", "€1.000,00 EUR" -> "€1.000 EUR", "€297,50" stays.
      return typeof out === 'string' ? out.replace(/([.,])00(?!\d)/, '') : out;
    };
    currency.mpTrimmed = true;
  }

  /* ------------------------------------------------------------------
     1. HOMEPAGE
     ------------------------------------------------------------------ */
  function scrollableAncestor(el) {
    while (el && el !== body && el !== html) {
      if (el.scrollHeight > el.clientHeight + 1) {
        var overflowY = window.getComputedStyle(el).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') { return el; }
      }
      el = el.parentElement;
    }
    return null;
  }

  function initHome() {
    if (!body.classList.contains('template-index')) { return; }

    var logo = document.querySelector('.logo-wrapper img.main-logo');
    if (logo && !logo.getAttribute('alt')) { logo.setAttribute('alt', 'Michel Piza'); }

    var main = document.getElementById('MainContent');
    var sections = main ? toArray(main.children).filter(function (el) { return el.classList.contains('shopify-section'); }) : [];
    var slides = sections.filter(function (el) { return el.classList.contains('home-image-freesize'); });
    // Only take over scrolling when the homepage is made of full-screen
    // images (and not in the theme editor). Otherwise the page scrolls as
    // usual and the logo keeps to the bar.
    if (designMode || slides.length < 2 || slides.length !== sections.length) {
      html.classList.add('mp-logo-small');
      return;
    }

    var footer = document.querySelector('footer.site-footer');
    var header = document.querySelector('header.site-header');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lastImage = slides.length - 1;
    var total = slides.length + (footer ? 1 : 0);
    var index = 0;
    var busy = false;
    var pending = 0;
    // An image slides away in .9s (transition in mp-redesign.css). A new
    // swipe or wheel click made while it moves is kept, and played as soon
    // as the image has (nearly) arrived, so no gesture is lost.
    var DURATION = reduceMotion ? 0 : 900;
    var LOCK = reduceMotion ? 300 : DURATION - 100;

    // Computers, phones and tablets alike: one image fills the screen and the
    // page moves one image at a time. The large logo in the menu bar shrinks
    // once the page moves on.
    html.classList.add('mp-home');
    // No transitions while the page sets itself up (see render() below).
    html.classList.add('mp-no-anim');
    if ('scrollRestoration' in window.history) { window.history.scrollRestoration = 'manual'; }
    window.scrollTo(0, 0);
    html.classList.add('mp-immersive');
    if (reduceMotion) { html.classList.add('mp-reduced-motion'); }

    slides.forEach(function (slide, i) {
      slide.style.zIndex = String(20 - i);
      slide.setAttribute('data-mp-slide', String(i));
      // After a newsletter sign-up the page reloads: open on that image,
      // where the thank-you (or the error) is shown.
      if (slide.querySelector('.mp-newsletter__message')) { index = i; }
    });

    var hint = document.createElement('div');
    hint.className = 'mp-scroll-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = 'Scroll';
    body.appendChild(hint);

    function render() {
      var visible = Math.min(index, lastImage);
      slides.forEach(function (slide, i) {
        var isCurrent = i === visible;
        slide.classList.toggle('is-past', i < visible);
        slide.classList.toggle('is-current', isCurrent);
        slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
        slide.inert = !isCurrent;
      });
      html.classList.toggle('mp-footer-open', !!footer && index === slides.length);
      html.classList.toggle('mp-moved', index > 0);
      updateLogo();
    }

    // The large logo over the first image. It stays as it is while SHOP or
    // DISCOVER is open, and shrinks into the bar once the page moves on or
    // the phone menu opens. Set as a class here rather than worked out in
    // the stylesheet, so every browser shows the same thing.
    function updateLogo() {
      var navOpen = !!header && (header.classList.contains('mobile-nav-open') ||
        (!wideScreen.matches && header.classList.contains('clicked')));
      html.classList.toggle('mp-logo-small', index !== 0 || navOpen);
    }
    if (header && 'MutationObserver' in window) {
      new MutationObserver(updateLogo).observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    function go(next) {
      next = Math.max(0, Math.min(total - 1, next));
      if (next === index) { return; }
      // Scrolling closes an open menu.
      if (html.classList.contains('mp-veiled')) { closeMenus(); }
      index = next;
      busy = true;
      render();
      window.setTimeout(function () {
        busy = false;
        var queued = pending;
        pending = 0;
        if (queued && !paused()) { go(index + queued); }
      }, LOCK);
    }
    // While an image is moving, remember one more step.
    function move(stepBy) {
      if (busy) { pending = stepBy; } else { go(index + stepBy); }
    }

    // While the bag, the search or the phone menu is open, the images stay
    // where they are.
    function paused() {
      return html.classList.contains('mp-drawer-open') ||
        html.classList.contains('js-drawer-open') ||
        body.classList.contains('js-drawer-open') ||
        (!!header && header.classList.contains('mobile-nav-open'));
    }

    // Only gestures on the images, the footer or the menu bar move the page.
    // Anything else on top (cookie banner, search, bag) keeps its own scroll.
    function ours(target) {
      if (!target || target === body || target === html || target === document) { return true; }
      if (!target.closest) { return false; }
      return !!target.closest('#MainContent, footer.site-footer, header.site-header, .mp-veil');
    }

    function footerAtTop() { return !footer || footer.scrollTop <= 0; }

    /* Mouse wheel and trackpad. A trackpad goes on sending smaller and
       smaller movements after a swipe (momentum). The page moves once per
       swipe, and again as soon as a new swipe starts, even while the last
       one is still dying away: growing or steady movement is a hand on the
       trackpad or a wheel turning, shrinking movement is the tail. */
    var wheelLog = [];
    var wheelSum = 0;
    var lastWheel = 0;
    var freshGesture = true; // nothing has moved for this gesture yet
    var dyingAway = false;   // its movement has started to shrink
    function average(list, count) {
      var part = list.slice(-count);
      var sum = 0;
      for (var i = 0; i < part.length; i += 1) { sum += part[i]; }
      return part.length ? sum / part.length : 0;
    }

    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || paused() || !ours(e.target)) { return; } // pinch to zoom
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { return; } // sideways: back and forward
      var scroller = scrollableAncestor(e.target);
      // Menus and a tall footer scroll on their own. At the top of the
      // footer, scrolling up goes back to the last image.
      if (scroller && !(scroller === footer && e.deltaY < 0 && footerAtTop())) { return; }
      e.preventDefault();

      var unit = e.deltaMode === 1 ? 32 : (e.deltaMode === 2 ? window.innerHeight : 1);
      var delta = e.deltaY * unit;
      var now = Date.now();
      if (now - lastWheel > 200) { // a pause: a new gesture
        wheelLog = [];
        wheelSum = 0;
        freshGesture = true;
        dyingAway = false;
      }
      lastWheel = now;
      if (!delta) { return; }
      if (wheelSum && (wheelSum > 0) !== (delta > 0)) { wheelSum = 0; }
      wheelSum += delta;
      wheelLog.push(Math.abs(delta));
      if (wheelLog.length > 150) { wheelLog.shift(); }

      // Rising: the movement holds or grows, or two quick increases in a row
      // (a new swipe starting while the last one is still dying away).
      var n = wheelLog.length;
      var onset = n >= 3 && wheelLog[n - 1] >= 8 &&
        wheelLog[n - 1] > 1.4 * wheelLog[n - 2] && wheelLog[n - 2] > 1.2 * wheelLog[n - 3];
      var rising = onset || average(wheelLog, 10) >= average(wheelLog, 70);
      if (!rising) { dyingAway = true; }
      // One click of a mouse wheel is enough (4px on a Mac); on a trackpad a
      // few pixels of deliberate movement, so a resting finger does nothing
      // and the last faint pixels of a long momentum never count.
      var strong = e.deltaMode !== 0 || Math.abs(e.wheelDeltaY || 0) >= 120 || Math.abs(delta) >= 4;
      if (!rising || !(strong || (freshGesture && Math.abs(wheelSum) >= 8))) { return; }
      // While an image moves, only a new gesture counts (not the rest of
      // the one that started the move).
      if (busy && !freshGesture && !dyingAway) { return; }
      freshGesture = false;
      dyingAway = false;
      wheelSum = 0;
      // From here on, compare this swipe with itself only.
      wheelLog = wheelLog.slice(-3);
      move(delta > 0 ? 1 : -1);
    }, { passive: false });

    window.addEventListener('keydown', function (e) {
      var t = e.target;
      if (paused()) { return; }
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT|BUTTON)$/.test(t.tagName))) { return; }
      var k = e.key;
      if (k === 'ArrowDown' || k === 'PageDown' || (k === ' ' && !e.shiftKey)) {
        e.preventDefault(); if (!busy) { go(index + 1); }
      } else if (k === 'ArrowUp' || k === 'PageUp' || (k === ' ' && e.shiftKey)) {
        e.preventDefault(); if (!busy) { go(index - 1); }
      } else if (k === 'Home') {
        e.preventDefault(); go(0);
      } else if (k === 'End') {
        e.preventDefault(); go(total - 1);
      }
    });

    /* Phones and tablets: a swipe up or down moves one image as soon as the
       finger has travelled far enough (or flicked); the page itself never
       scrolls or bounces. */
    var touch = null;
    function step(dx, dy, flick) {
      if (Math.abs(dy) <= Math.abs(dx)) { return 0; }
      if (Math.abs(dy) >= 50 || (flick && Math.abs(dy) >= 20)) { return dy > 0 ? 1 : -1; }
      return 0;
    }
    window.addEventListener('touchstart', function (e) {
      touch = null;
      if (!e.touches || e.touches.length !== 1 || paused() || !ours(e.target)) { return; }
      // Zoomed in with two fingers: let the finger move around the picture.
      if (window.visualViewport && window.visualViewport.scale > 1.01) { return; }
      var p = e.touches[0];
      var scroller = scrollableAncestor(e.target);
      touch = {
        x: p.clientX,
        y: p.clientY,
        time: Date.now(),
        done: false,
        scroller: scroller,
        // In a footer taller than the screen, pulling down goes back to the
        // last image only when the footer is already at its top.
        backFromFooter: !!scroller && scroller === footer && footerAtTop()
      };
    }, { passive: true });

    window.addEventListener('touchmove', function (e) {
      if (!touch) { return; }
      if (!e.touches || e.touches.length !== 1 || paused()) { touch = null; return; }
      var p = e.touches[0];
      var dx = touch.x - p.clientX;
      var dy = touch.y - p.clientY;
      if (touch.scroller && !(touch.backFromFooter && dy < 0)) { return; } // it scrolls itself
      if (e.cancelable) { e.preventDefault(); }
      if (touch.done) { return; }
      var s = step(dx, dy, false);
      if (s) { touch.done = true; move(s); }
    }, { passive: false });

    window.addEventListener('touchend', function (e) {
      var t = touch;
      touch = null;
      if (!t || t.done || paused()) { return; }
      var p = e.changedTouches && e.changedTouches[0];
      if (!p) { return; }
      var dx = t.x - p.clientX;
      var dy = t.y - p.clientY;
      if (t.scroller && !(t.backFromFooter && dy < 0)) { return; }
      var s = step(dx, dy, Date.now() - t.time < 250);
      if (s) { move(s); }
    }, { passive: true });

    window.addEventListener('touchcancel', function () { touch = null; }, { passive: true });

    render();
    // The first state is drawn as it is; transitions only after that.
    void html.offsetWidth;
    window.setTimeout(function () { html.classList.remove('mp-no-anim'); }, 60);
  }

  /* ------------------------------------------------------------------
     2. COLLECTIONS
     ------------------------------------------------------------------ */
  // Colour groups are read from each product's Color option ("Apple Green",
  // "Glossy Bordeaux"...). First match wins, so the order matters.
  var COLOR_RULES = [
    ['print', /python|zebra|leopard|animal|polka|roccia|print|croc|snake/],
    ['gold', /gold|silver|bronze|metallic/],
    ['orange', /orange|rust|terracotta/],
    ['red', /bordeaux|burgundy|wine|cherry|scarlet|rosso|\bred\b/],
    ['pink', /pink|rose|blush/],
    ['purple', /purple|lilac|violet|plum/],
    ['green', /green|acqua|aqua|teal|olive|sage|mint|verde/],
    ['blue', /blue|denim|navy|cobalt|azure/],
    ['yellow', /yellow|lemon|butter|mustard|giallo/],
    ['khaki', /khaki/],
    ['brown', /brown|mocha|chocolate|cognac|caramel|camel|marrone/],
    ['grey', /grey|gray|melange|charcoal|grigio/],
    ['beige', /beige|nude|sand|shearling|natural|ecru/],
    ['white', /white|ivory|cream|moir|bianco|panna/],
    ['black', /black|nero/]
  ];
  var COLOR_ORDER = ['black', 'white', 'beige', 'brown', 'khaki', 'grey', 'green', 'blue', 'yellow', 'orange', 'red', 'pink', 'purple', 'gold', 'print'];
  var COLOR_LABELS = { print: 'Prints' };

  function matchColor(value) {
    var v = String(value || '').toLowerCase();
    for (var i = 0; i < COLOR_RULES.length; i++) {
      if (COLOR_RULES[i][1].test(v)) { return COLOR_RULES[i][0]; }
    }
    return '';
  }
  function colorGroup(name, fallback) {
    return matchColor(name) || matchColor(fallback) || String(fallback || '').toLowerCase().trim();
  }
  function colorLabel(group) {
    if (COLOR_LABELS[group]) { return COLOR_LABELS[group]; }
    return group ? group.charAt(0).toUpperCase() + group.slice(1) : '';
  }

  function initCollection() {
    var cards = toArray(document.querySelectorAll('.grid-view-item.product-card'));
    if (!cards.length) { return; }

    var state = { color: 'all', size: 'all', model: 'all' };

    cards.forEach(function (card) {
      var model = card.getAttribute('data-model');
      if (model === null) {
        var titleEl = card.querySelector('.product-card__title');
        var title = titleEl ? titleEl.textContent : '';
        model = title.indexOf('|') > -1 ? title.split('|')[0] : '';
      }
      card.setAttribute('data-mp-model', model.trim().toUpperCase());
      card.setAttribute('data-mp-color', colorGroup(card.getAttribute('data-color-name'), card.getAttribute('color-variant')));
    });

    // One FILTERS menu: the rows Style, Model, Colour and Size sit in the
    // FILTERS panel (.product-filters). The Style links move into it from
    // the old STYLE menu, with Boots after Heels.
    var panel = document.querySelector('.filters-outer-wrapper .product-filters');
    var styleRow = document.querySelector('.collection-custom-filters');
    if (styleRow && !styleRow.querySelector('a[href*="/collections/boots"]')) {
      var links = toArray(styleRow.querySelectorAll('a'));
      var heels = links.filter(function (a) { return /\/collections\/mules/.test(a.getAttribute('href') || ''); })[0];
      var boots = document.createElement('a');
      boots.href = '/collections/boots';
      boots.textContent = 'Boots';
      if (window.location.pathname.indexOf('/collections/boots') === 0) {
        links.forEach(function (a) { a.classList.remove('current'); });
        boots.className = 'current';
      }
      if (heels && heels.parentNode) {
        heels.parentNode.insertBefore(boots, heels.nextSibling);
      } else {
        styleRow.appendChild(boots);
      }
    }
    if (styleRow && panel && !panel.querySelector('.mp-style-row')) {
      var styleOptions = makeRow('mp-style-row', 'Style');
      toArray(styleRow.querySelectorAll('a')).forEach(function (a) {
        // Links on this domain (some pointed at the .myshopify.com address).
        try { a.setAttribute('href', new URL(a.getAttribute('href'), window.location.href).pathname); } catch (err) { /* keep it */ }
        if (a.classList.contains('current')) { a.setAttribute('aria-current', 'page'); }
        styleOptions.appendChild(a);
      });
      panel.insertBefore(styleOptions.parentNode, panel.firstChild);
    }

    // Colour list rebuilt from the products on this page, grouped.
    var firstColor = document.querySelector('.filter-options .filter-color');
    var colorBox = firstColor ? firstColor.parentElement : null;
    if (colorBox) {
      var present = {};
      cards.forEach(function (card) {
        var g = card.getAttribute('data-mp-color');
        if (g) { present[g] = true; }
      });
      var groups = COLOR_ORDER.filter(function (g) { return present[g]; })
        .concat(Object.keys(present).filter(function (g) { return COLOR_ORDER.indexOf(g) === -1; }).sort());
      colorBox.innerHTML = '';
      groups.forEach(function (g) {
        colorBox.appendChild(makeOption('filter-color', 'data-color', g, colorLabel(g)));
      });
      var clearColor = makeOption('filter-color', 'data-color', 'tutti', 'Clear');
      clearColor.classList.add('mp-clear');
      colorBox.appendChild(clearColor);
    }
    each('.filter-options .filter-number[data-number="tutti"]', function (el) {
      el.classList.add('mp-clear');
      if (/^\s*clear\s*$/i.test(el.textContent)) { el.textContent = 'Clear'; }
    });

    // Model row, in the panel after Style.
    var counts = {};
    cards.forEach(function (card) {
      var m = card.getAttribute('data-mp-model');
      if (m) { counts[m] = (counts[m] || 0) + 1; }
    });
    var models = Object.keys(counts).sort();
    if (models.length > 1 && panel) {
      var modelOptions = makeRow('mp-model-row', 'Model');
      models.forEach(function (m) {
        modelOptions.appendChild(makeOption('filter-model', 'data-model-filter', m, m.charAt(0) + m.slice(1).toLowerCase()));
      });
      var clearModel = makeOption('filter-model', 'data-model-filter', 'all', 'Clear');
      clearModel.classList.add('mp-clear');
      modelOptions.appendChild(clearModel);
      var styleBlock = panel.querySelector('.mp-style-row');
      panel.insertBefore(modelOptions.parentNode, styleBlock ? styleBlock.nextSibling : panel.firstChild);

      // Shareable links such as /collections/all?model=zay
      var wanted = (new URLSearchParams(window.location.search).get('model') || '').trim().toUpperCase();
      if (wanted && counts[wanted]) { state.model = wanted; }
    }
    // FILTERS (2): how many filters are on, seen with the panel closed.
    var filtersWord = document.querySelector('.filters-outer-wrapper .filters-toggle');
    var countEl = null;
    if (filtersWord) {
      countEl = document.createElement('span');
      countEl.className = 'mp-filter-count';
      filtersWord.appendChild(countEl);
    }

    var empty = document.createElement('p');
    empty.className = 'mp-empty';
    empty.textContent = 'No styles match this selection.';
    empty.hidden = true;
    var grid = cards[0].closest('ul') || cards[0].parentNode;
    if (grid && grid.parentNode) { grid.parentNode.insertBefore(empty, grid.nextSibling); }

    function makeOption(cls, attr, value, text) {
      var span = document.createElement('span');
      span.className = cls;
      span.setAttribute(attr, value);
      span.setAttribute('role', 'button');
      span.setAttribute('tabindex', '0');
      var square = document.createElement('div');
      square.className = 'square';
      span.appendChild(square);
      span.appendChild(document.createTextNode(text));
      return span;
    }

    // A row of the panel: the name on the left, the options after it.
    function makeRow(cls, name) {
      var row = document.createElement('div');
      row.className = 'single-filter ' + cls;
      var label = document.createElement('div');
      label.className = 'filter-name';
      label.textContent = name;
      var options = document.createElement('div');
      options.className = 'filter-options';
      row.appendChild(label);
      row.appendChild(options);
      return options;
    }

    function mark(selector, attr, value, activeClass) {
      each(selector, function (el) {
        var on = el.getAttribute(attr) === value;
        el.classList.toggle(activeClass, on);
        if (el.tagName === 'BUTTON') { el.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      });
    }

    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var item = card.closest('li') || card;
        var sizes = (card.getAttribute('number-variant') || '').split(',')
          .map(function (s) { return s.trim(); })
          .filter(Boolean);
        var ok = (state.color === 'all' || card.getAttribute('data-mp-color') === state.color) &&
          (state.size === 'all' || sizes.indexOf(state.size) > -1) &&
          (state.model === 'all' || card.getAttribute('data-mp-model') === state.model);
        item.style.display = ok ? '' : 'none';
        if (ok) { shown += 1; }
      });
      empty.hidden = shown > 0;
      mark('.filter-options .filter-color', 'data-color', state.color === 'all' ? 'tutti' : state.color, 'active');
      mark('.filter-options .filter-number', 'data-number', state.size === 'all' ? 'tutti' : state.size, 'selected');
      mark('.filter-options .filter-model', 'data-model-filter', state.model, 'active');
      each('.filter-options', function (box) {
        var chosen = (state.color !== 'all' && !!box.querySelector('.filter-color')) ||
          (state.size !== 'all' && !!box.querySelector('.filter-number')) ||
          (state.model !== 'all' && !!box.querySelector('.filter-model'));
        box.classList.toggle('mp-has-selection', chosen);
      });
      if (countEl) {
        var on = (state.color !== 'all' ? 1 : 0) + (state.size !== 'all' ? 1 : 0) + (state.model !== 'all' ? 1 : 0);
        countEl.textContent = on ? '(' + on + ')' : '';
      }
    }

    function handle(target) {
      var el = target && target.closest ? target.closest('.filter-options .filter-color, .filter-options .filter-number, .filter-options .filter-model') : null;
      if (!el) { return false; }
      var v;
      if (el.classList.contains('filter-color')) {
        v = el.getAttribute('data-color');
        state.color = (v === 'tutti' || v === state.color) ? 'all' : v;
      } else if (el.classList.contains('filter-number')) {
        v = el.getAttribute('data-number');
        state.size = (v === 'tutti' || v === state.size) ? 'all' : v;
      } else {
        v = el.getAttribute('data-model-filter');
        state.model = (v === 'all' || v === state.model) ? 'all' : v;
        try {
          var url = new URL(window.location.href);
          if (state.model === 'all') { url.searchParams.delete('model'); } else { url.searchParams.set('model', state.model.toLowerCase()); }
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (err) { /* older browsers: keep the URL as it is */ }
      }
      apply();
      return true;
    }

    // Capture phase: runs before the theme's own filter scripts, which
    // could not combine filters (choosing a size used to undo the colour).
    document.addEventListener('click', function (e) {
      if (handle(e.target)) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.matches &&
          e.target.matches('.filter-options .filter-color, .filter-options .filter-number, .filter-options .filter-model')) {
        if (handle(e.target)) { e.preventDefault(); e.stopImmediatePropagation(); }
      }
    }, true);

    apply();
  }

  /* One FILTERS menu (Style, Model, Colour, Size). Computers: it opens when
     the pointer rests on the word and closes when it leaves; a click keeps
     it open until the page scrolls, a click elsewhere or Escape. It lies
     over the faded page. Phones: a tap opens it and a second tap closes it. */
  function initFilterToolbar() {
    var toolbar = document.querySelector('.filters-outer-wrapper');
    if (!toolbar) { return; }
    var toggle = toolbar.querySelector('.filters-toggle');
    var panel = toolbar.querySelector('.product-filters');
    if (!toggle || !panel) { return; }

    if (!panel.id) { panel.id = 'MpFiltersPanel'; }
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    toggle.setAttribute('aria-controls', panel.id);

    var open = false;
    var pinned = false;
    var openTimer = null;
    var closeTimer = null;
    var scrollAtOpen = 0;
    var carry = false; // opened during a wheel gesture still going on

    function setOpen(on, pin) {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      if (on && !open) {
        closeMenus('filters');
        scrollAtOpen = window.pageYOffset || 0;
        carry = wheelGoingOn();
      }
      open = !!on;
      pinned = open && !!pin;
      panel.classList.toggle('visible', open);
      toolbar.classList.toggle('mp-filters-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      setVeil('filters', open && wideScreen.matches);
    }
    setOpen(panel.classList.contains('visible'), true);

    // Every row starts where the word FILTERS starts.
    function measure() {
      var box = toolbar.getBoundingClientRect();
      var cs = window.getComputedStyle(toolbar);
      var border = parseFloat(cs.borderLeftWidth) || 0;
      var pad = parseFloat(cs.paddingLeft) || 0;
      var word = toggle.getBoundingClientRect().left +
        (parseFloat(window.getComputedStyle(toggle).paddingLeft) || 0);
      var fromEdge = Math.max(0, Math.round(word - box.left - border));
      toolbar.style.setProperty('--mp-filter-indent-abs', fromEdge + 'px');
      toolbar.style.setProperty('--mp-filter-indent', Math.max(0, fromEdge - Math.round(pad)) + 'px');
    }
    measure();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 150);
    });

    // Click, tap, Enter or Space on FILTERS. Capture phase on the toolbar,
    // so the theme's own toggle on the word does not run as well.
    toolbar.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.filters-toggle')) { return; }
      e.preventDefault();
      e.stopPropagation();
      if (open && (pinned || !wideScreen.matches)) { setOpen(false); } else { setOpen(true, true); }
    }, true);
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle.click();
      }
    });
    // Keyboard: tabbing out of the panel closes it.
    toolbar.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (open && wideScreen.matches && to && !toolbar.contains(to)) { setOpen(false); }
    });

    // Pointer on a computer.
    toggle.addEventListener('pointerenter', function (e) {
      if (!isMouse(e) || !wideScreen.matches) { return; }
      window.clearTimeout(closeTimer);
      if (open) { return; }
      // A short wait, so a pointer only passing over the word opens nothing.
      openTimer = window.setTimeout(function () { setOpen(true, false); }, 90);
    });
    toggle.addEventListener('pointerleave', function () { window.clearTimeout(openTimer); });
    toolbar.addEventListener('pointerenter', function () { window.clearTimeout(closeTimer); });
    toolbar.addEventListener('pointerleave', function (e) {
      if (!isMouse(e)) { return; }
      window.clearTimeout(openTimer);
      if (!open || pinned || !wideScreen.matches) { return; }
      closeTimer = window.setTimeout(function () { if (!pinned) { setOpen(false); } }, 250);
    });

    // Scrolling, a click elsewhere or Escape closes it (computers).
    window.addEventListener('scroll', function () {
      if (!open || !wideScreen.matches) { return; }
      if (carry && wheelGoingOn()) { scrollAtOpen = window.pageYOffset || 0; return; }
      carry = false;
      if (Math.abs((window.pageYOffset || 0) - scrollAtOpen) > 6) { setOpen(false); }
    }, { passive: true });
    window.addEventListener('wheel', function (e) {
      if (!open || !wideScreen.matches) { return; }
      if (carry && wheelContinues()) { scrollAtOpen = window.pageYOffset || 0; return; }
      carry = false;
      if (Math.abs(e.deltaY) > 3) { setOpen(false); }
    }, { passive: true });
    document.addEventListener('click', function (e) {
      if (open && wideScreen.matches && !toolbar.contains(e.target)) { setOpen(false); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) { setOpen(false); }
    });
    document.addEventListener('mp:close-menus', function (e) {
      if (open && (!e.detail || e.detail.except !== 'filters')) { setOpen(false); }
    });
    function onWidthChange() { if (open) { setOpen(false); } measure(); }
    if (wideScreen.addEventListener) {
      wideScreen.addEventListener('change', onWidthChange);
    } else if (wideScreen.addListener) {
      wideScreen.addListener(onWidthChange);
    }
  }

  /* ------------------------------------------------------------------
     3. PRODUCT PAGE
     ------------------------------------------------------------------ */
  function initProduct() {
    if (!body.classList.contains('template-product')) { return; }

    // Colour name next to "Color", previewed on hover.
    var colorTitle = document.querySelector('.custom-color-selector .variant-title');
    var current = document.querySelector('.single-swatch.current label');
    if (colorTitle && current) {
      var base = current.textContent.trim();
      var nameEl = document.createElement('span');
      nameEl.className = 'mp-color-name';
      nameEl.textContent = base;
      colorTitle.appendChild(nameEl);
      each('.single-swatch', function (swatch) {
        var label = swatch.querySelector('label');
        if (!label) { return; }
        var name = label.textContent.trim();
        var link = swatch.querySelector('a');
        if (link) { link.setAttribute('aria-label', name); }
        swatch.setAttribute('title', name);
        swatch.addEventListener('mouseenter', function () { nameEl.textContent = name; });
        swatch.addEventListener('mouseleave', function () { nameEl.textContent = base; });
      });
    }

    // One sizing message: the fit note under the sizes. Remove the line in
    // the description that repeats it.
    var fit = document.querySelector('.fit-shoe');
    if (fit && fit.textContent.trim()) {
      each('.main-description em, .main-description i, .main-description strong, .main-description b', function (el) {
        if (!/runs small|size up|sizing up|between sizes|half a size/i.test(el.textContent)) { return; }
        var p = el.closest('p');
        var target = (p && p.textContent.trim() === el.textContent.trim()) ? p : el;
        if (target.parentNode) { target.parentNode.removeChild(target); }
      });
    }

    // "Size guide" next to the size label, opens the Sizing panel.
    var sizing = document.querySelector('.custom-details.sizing');
    var sizeWrapper = null;
    each('.product-form__controls-group .selector-wrapper', function (wrapper) {
      if (!sizeWrapper && wrapper.querySelector('.variant-sizes')) { sizeWrapper = wrapper; }
    });
    var sizeLabel = sizeWrapper ? sizeWrapper.querySelector(':scope > label') : null;
    if (sizing && sizeLabel) {
      var head = document.createElement('div');
      head.className = 'mp-size-head';
      sizeLabel.parentNode.insertBefore(head, sizeLabel);
      head.appendChild(sizeLabel);
      var guide = document.createElement('button');
      guide.type = 'button';
      guide.className = 'mp-size-guide';
      guide.textContent = 'Size guide';
      guide.addEventListener('click', function () {
        var title = sizing.querySelector('.section-title');
        var content = sizing.querySelector('.section-content');
        if (title && content && window.getComputedStyle(content).display === 'none') { title.click(); }
        // After the panel has opened, bring it up under the menu bar.
        window.setTimeout(function () {
          var top = sizing.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }, 420);
      });
      head.appendChild(guide);
    }

    // Pickup information directly under the button.
    var store = document.querySelector('.product-single__store-availability-container');
    var form = document.querySelector('.product-single__meta form.product-form');
    if (store && form && form.parentNode) {
      form.parentNode.insertBefore(store, form.nextSibling);
    }

    // Details / Sizing: keep the + / − marker in step with the panel.
    each('.custom-details', function (block) {
      var title = block.querySelector('.section-title');
      var content = block.querySelector('.section-content');
      if (!title || !content) { return; }
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      var sync = function () {
        window.setTimeout(function () {
          var open = window.getComputedStyle(content).display !== 'none';
          block.classList.toggle('is-open', open);
          title.setAttribute('aria-expanded', open ? 'true' : 'false');
        }, 30);
      };
      title.addEventListener('click', sync);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); title.click(); }
      });
      sync();
    });
  }

  // Size systems above the sizes, as on Aquazzura. The numbers follow the
  // size guide (IT/EU = EU, US = IT - 30) and the usual UK and Mexican
  // conversions (UK = IT - 33, MX = IT - 13). Only the labels change: the
  // bag and the order keep the Italian size. The choice is remembered, and a
  // first visit from the UK, the US or Mexico starts on that system.
  var SIZE_SYSTEMS = [
    { id: 'it', label: 'IT/EU', offset: 0 },
    { id: 'uk', label: 'UK', offset: -33 },
    { id: 'us', label: 'US', offset: -30 },
    { id: 'mx', label: 'MX', offset: -13 }
  ];
  var SIZE_SYSTEM_BY_COUNTRY = { GB: 'uk', US: 'us', MX: 'mx' };

  function initSizeSystems() {
    if (!body.classList.contains('template-product')) { return; }
    var wrap = document.querySelector('.product-form .variant-sizes');
    if (!wrap) { return; }
    var labels = toArray(wrap.querySelectorAll('label'));
    var values = labels.map(function (label) {
      var input = document.getElementById(label.getAttribute('for'));
      var raw = String((input && input.value) || label.textContent).trim().replace(',', '.');
      var number = parseFloat(raw);
      return /^\d+(\.\d+)?$/.test(raw) && number >= 30 && number <= 50 ? number : null;
    });
    // Shoe sizes only (not one-size items).
    if (!values.some(function (v) { return v !== null; })) { return; }
    labels.forEach(function (label) { label.setAttribute('data-mp-it', label.textContent.trim()); });

    var list = document.createElement('ul');
    list.className = 'mp-size-systems';
    list.setAttribute('aria-label', 'Size system');
    var buttons = SIZE_SYSTEMS.map(function (system) {
      var li = document.createElement('li');
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = system.label;
      button.setAttribute('data-system', system.id);
      button.setAttribute('aria-pressed', 'false');
      li.appendChild(button);
      list.appendChild(li);
      return button;
    });
    wrap.parentNode.insertBefore(list, wrap);

    var headLabel = document.querySelector('.mp-size-head > label');
    var headSuffix = null;
    if (headLabel) {
      headSuffix = document.createElement('span');
      headSuffix.className = 'mp-size-system-name';
      headLabel.appendChild(headSuffix);
    }

    // The size guide gets UK and MX columns.
    var table = document.querySelector('.custom-details.sizing table');
    if (table && !table.getAttribute('data-mp-systems')) {
      table.setAttribute('data-mp-systems', 'true');
      toArray(table.rows).forEach(function (row, i) {
        var it = row.cells[1] ? parseFloat(row.cells[1].textContent.replace(',', '.')) : NaN;
        [['UK', -33], ['MX', -13]].forEach(function (pair) {
          var cell = row.insertCell(-1);
          cell.textContent = i === 0 ? pair[0] : (isNaN(it) ? '' : format(it + pair[1]));
        });
      });
    }

    function format(n) { return String(Math.round(n * 10) / 10); }
    function find(id) { return SIZE_SYSTEMS.filter(function (s) { return s.id === id; })[0] || SIZE_SYSTEMS[0]; }
    function apply(id, remember) {
      var system = find(id);
      labels.forEach(function (label, i) {
        label.textContent = (system.offset === 0 || values[i] === null)
          ? label.getAttribute('data-mp-it')
          : format(values[i] + system.offset);
      });
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-system') === system.id ? 'true' : 'false');
      });
      if (headSuffix) { headSuffix.textContent = system.offset === 0 ? '' : ' (' + system.label + ')'; }
      if (remember) {
        try { window.localStorage.setItem('mp-size-system', system.id); } catch (e) { /* not stored */ }
      }
    }

    list.addEventListener('click', function (e) {
      var button = e.target.closest('button[data-system]');
      if (button) { apply(button.getAttribute('data-system'), true); }
    });

    var start = null;
    try { start = window.localStorage.getItem('mp-size-system'); } catch (e) { start = null; }
    if (!start) {
      var country = window.Shopify && window.Shopify.country;
      start = SIZE_SYSTEM_BY_COUNTRY[country] || 'it';
    }
    apply(start, false);
  }

  /* ------------------------------------------------------------------
     4. TEXT PAGES (Our story)
     ------------------------------------------------------------------ */
  // Text written as one paragraph with blank lines (<br><br>) is split into
  // real paragraphs, so the closing line can be set as a statement.
  function initStory() {
    each('.featured-row__subtext', function (box) {
      var ps = box.querySelectorAll('p');
      if (ps.length !== 1) { return; }
      var p = ps[0];
      var parts = p.innerHTML.split(/(?:\s*<br\s*\/?>\s*){2,}/i)
        .map(function (part) { return part.trim(); })
        .filter(Boolean);
      if (parts.length < 2) { return; }
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        var np = document.createElement('p');
        np.innerHTML = part;
        frag.appendChild(np);
      });
      p.parentNode.replaceChild(frag, p);
    });
  }

  /* ------------------------------------------------------------------
     5. BAG
     ------------------------------------------------------------------ */
  // The (dust)bag row sits outside the rows the theme redraws, so it stays
  // when a pair is removed. Its count follows the number of pairs, and it
  // goes away only when no pair is left.
  function initCart() {
    var block = document.querySelector('[data-mp-dustbag]');
    var lines = document.querySelector('[data-cart-line-items]');
    if (!block || !lines || !window.fetch || !('MutationObserver' in window)) { return; }
    var ids = (block.getAttribute('data-dustbag-ids') || '').split(',').filter(Boolean);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var timer = null;

    function refresh() {
      window.fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var pairs = 0;
          (cart.items || []).forEach(function (item) {
            if (ids.indexOf(String(item.product_id)) === -1) { pairs += item.quantity; }
          });
          block.style.display = pairs > 0 ? '' : 'none';
          each('[data-mp-dustbag-qty]', function (el) { el.textContent = String(pairs); });
        })
        .catch(function () { /* leave the row as it was rendered */ });
    }

    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(refresh, 250);
    }).observe(lines, { childList: true, subtree: true });
  }

  // When a quantity is raised above what is in stock, Shopify answers with
  // an error and the theme read that as an empty bag ("Your bag is empty"
  // while the pair was still there). Hand the theme the real bag instead and
  // say how many are available.
  function initCartQuantityErrors() {
    if (!body.classList.contains('template-cart') || !window.fetch || typeof window.Response !== 'function') { return; }
    var nativeFetch = window.fetch;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function showNotice(line, text) {
      var row = document.querySelector('[data-cart-line-items] [data-cart-item-index="' + line + '"]');
      if (!row) { return; }
      each('[data-cart-quantity-error-message-wrapper]', function (wrapper) {
        var message = wrapper.querySelector('[data-cart-quantity-error-message]');
        if (message) { message.textContent = text; }
        wrapper.classList.remove('hide');
      }, row);
    }

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var request = nativeFetch.apply(window, arguments);
      if (!/\/cart\/change(\.js)?(\?|$)/.test(url)) { return request; }
      return request.then(function (response) {
        if (response.ok) { return response; }
        return response.clone().json().catch(function () { return {}; }).then(function (error) {
          return nativeFetch.call(window, root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (cartResponse) { return cartResponse.json(); })
            .then(function (cart) {
              var line = 0;
              try { line = JSON.parse((init && init.body) || '{}').line || 0; } catch (err) { line = 0; }
              var available = String((error && (error.description || error.message)) || '').match(/(\d+)/);
              var text = available ? 'Only ' + available[1] + ' available.' : 'This quantity is not available.';
              // After the theme has redrawn the bag.
              window.setTimeout(function () { showNotice(line, text); }, 150);
              return new window.Response(JSON.stringify(cart), {
                status: 200,
                headers: { 'Content-Type': 'application/json' }
              });
            });
        }).catch(function () { return response; });
      });
    };
  }

  // Menu bar on computers: SHOP and DISCOVER open as a list when the pointer
  // rests on them and close when it leaves. A click keeps the list open
  // until the page scrolls, a click elsewhere or Escape. The page behind
  // fades (the veil). Phones use the menu button as before.
  function initMenu() {
    var header = document.querySelector('header.site-header');
    var nav = document.getElementById('AccessibleNav');
    if (!header || !nav) { return; }
    var items = toArray(nav.querySelectorAll('.site-nav--has-dropdown'));
    if (!items.length) { return; }
    var openTimer = null;
    var closeTimer = null;
    var pinned = false;
    var scrollAtOpen = 0;
    var carry = false; // opened during a wheel gesture still going on

    function openItem() {
      return items.filter(function (el) { return el.classList.contains('site-nav--active-dropdown'); })[0] || null;
    }

    function show(item, pin) {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      pinned = !!item && !!pin;
      if (item && !openItem()) {
        closeMenus('menu');
        scrollAtOpen = window.pageYOffset || 0;
        carry = wheelGoingOn();
      }
      items.forEach(function (el) {
        var on = el === item;
        el.classList.toggle('site-nav--active-dropdown', on);
        var button = el.querySelector('.site-nav__link--main');
        if (button) { button.setAttribute('aria-expanded', on ? 'true' : 'false'); }
      });
      header.classList.toggle('clicked', !!item);
      setVeil('menu', !!item && wideScreen.matches);
    }

    items.forEach(function (item) {
      item.addEventListener('pointerenter', function (e) {
        if (!isMouse(e) || !wideScreen.matches) { return; }
        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);
        var current = openItem();
        if (current === item) { return; }
        // Straight away when moving from one menu to the other (a list kept
        // open by a click stays kept open); after a short pause otherwise,
        // so crossing the bar does not open it.
        var keep = !!current && pinned;
        openTimer = window.setTimeout(function () { show(item, keep); }, current ? 0 : 80);
      });
      item.addEventListener('pointerleave', function (e) {
        if (!isMouse(e)) { return; }
        window.clearTimeout(openTimer);
        if (pinned) { return; }
        closeTimer = window.setTimeout(function () {
          if (!pinned && openItem()) { show(null); }
        }, 220);
      });
      // A click (or Enter) on SHOP or DISCOVER keeps the list open; a second
      // click closes it. Links in the list work as usual.
      item.addEventListener('click', function (e) {
        if (!wideScreen.matches || !e.target.closest('.site-nav__link--main')) { return; }
        e.preventDefault();
        e.stopPropagation();
        if (openItem() === item && pinned) { show(null); } else { show(item, true); }
      }, true);
      // Keyboard: tabbing out of an open list closes it.
      item.addEventListener('focusout', function (e) {
        var to = e.relatedTarget;
        if (to && !item.contains(to) && openItem() === item) { show(null); }
      });
    });

    // The theme closes the menu in places of its own (scrolling down):
    // follow it, so the veil goes too.
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        if (!openItem()) {
          pinned = false;
          setVeil('menu', false);
          if (header.classList.contains('clicked') && wideScreen.matches) { header.classList.remove('clicked'); }
        }
      });
      items.forEach(function (el) { observer.observe(el, { attributes: true, attributeFilter: ['class'] }); });
    }

    function closeIfOpen() { if (openItem()) { show(null); } }
    window.addEventListener('scroll', function () {
      if (!openItem()) { return; }
      if (carry && wheelGoingOn()) { scrollAtOpen = window.pageYOffset || 0; return; }
      carry = false;
      if (Math.abs((window.pageYOffset || 0) - scrollAtOpen) > 6) { show(null); }
    }, { passive: true });
    window.addEventListener('wheel', function (e) {
      if (!openItem()) { return; }
      if (carry && wheelContinues()) { scrollAtOpen = window.pageYOffset || 0; return; }
      carry = false;
      if (Math.abs(e.deltaY) > 3) { show(null); }
    }, { passive: true });
    document.addEventListener('click', function (e) {
      if (openItem() && !nav.contains(e.target)) { show(null); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeIfOpen(); }
    });
    document.addEventListener('mp:close-menus', function (e) {
      if (!e.detail || e.detail.except !== 'menu') { closeIfOpen(); }
    });
    if (wideScreen.addEventListener) {
      wideScreen.addEventListener('change', closeIfOpen);
    } else if (wideScreen.addListener) {
      wideScreen.addListener(closeIfOpen);
    }
  }

  ready(function () {
    try { initMenu(); } catch (e) { if (window.console) { console.warn('[mp] menu', e); } }
    try { initMoney(); } catch (e) { if (window.console) { console.warn('[mp] money', e); } }
    try { initHome(); } catch (e) { if (window.console) { console.warn('[mp] home', e); } }
    try { initCollection(); } catch (e) { if (window.console) { console.warn('[mp] collection', e); } }
    try { initFilterToolbar(); } catch (e) { if (window.console) { console.warn('[mp] filter toolbar', e); } }
    try { initProduct(); } catch (e) { if (window.console) { console.warn('[mp] product', e); } }
    try { initSizeSystems(); } catch (e) { if (window.console) { console.warn('[mp] size systems', e); } }
    try { initStory(); } catch (e) { if (window.console) { console.warn('[mp] story', e); } }
    try { initCart(); } catch (e) { if (window.console) { console.warn('[mp] bag', e); } }
    try { initCartQuantityErrors(); } catch (e) { if (window.console) { console.warn('[mp] bag quantity', e); } }
  });
})();
